"use client";

import { useSidebar } from "@/context/sidebar-context";
import classNames from "classnames";
import { FocusTrap } from "focus-trap-react";
import { useEffect } from "react";

const Sidebar = () => {
  const { isOpen, Component, close } = useSidebar();

  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("overflow-hidden");
    } else {
      document.documentElement.classList.remove("overflow-hidden");
    }
  }, [isOpen]);

  return (
    <>
      <div
        onClick={close}
        className={classNames(
          `bg-gray-500 w-full h-[100vh] fixed top-0 left-0 z-30 transition ease-in-out duration-200 pointer-events-none`,
          {
            "opacity-0 pointer-events-none": !isOpen,
            "opacity-75 pointer-events-auto": isOpen,
          }
        )}
      />

      <FocusTrap active={isOpen}>
        <aside
          className={classNames(
            "transition ease-in-out duration-200 fixed z-40 w-[390px] h-dvh max-w-full right-0 top-0 bg-sand-500 overflow-y-auto ",
            isOpen ? "translate-x-0" : "translate-x-full"
          )}
        >
          <div>{Component}</div>
        </aside>
      </FocusTrap>
    </>
  );
};

export default Sidebar;
